import { render } from "./ReturnPortalModal.vue?vue&type=template&id=4c81d323"
import script from "./ReturnPortalModal.vue?vue&type=script&lang=js"
export * from "./ReturnPortalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__